module.exports = __webpack_public_path__ + "img/people.014c0f44.svg";